import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';

const selectFarmToTablePageDomain = (state: ApplicationRootState) => state.farmToTablePage || initialState;

const selectFarmToTablePage = () => createSelector(selectFarmToTablePageDomain, (substate) => substate);

const selectLoading = () => createSelector(selectFarmToTablePageDomain, (substate) => substate.loading);
const selectSections = () => createSelector(selectFarmToTablePageDomain, (substate) => substate.sections);
const selectNoteItemLoading = () => createSelector(selectFarmToTablePageDomain, (substate) => substate.loadingNote);

export default selectFarmToTablePage;
export { selectFarmToTablePageDomain, selectLoading, selectSections, selectNoteItemLoading };
